













import { Component, Vue, Prop } from 'vue-property-decorator';
import { IProfileButton, nameOrNull } from './types';

@Component
export default class ProfileButton extends Vue implements IProfileButton {
  @Prop({ type: Boolean, default: false })
  public active!: boolean;

  @Prop({ type: Boolean, default: false })
  public disabled!: boolean;

  @Prop({ type: String, default: '' })
  public to!: string;

  @Prop({ type: [String, Number], default: '' })
  public indicator!: string | number;

  get isLinkNotActive(): boolean {
    return !!this.to && !this.active;
  }

  get componentType(): string {
    if (this.disabled) return 'div';
    return this.isLinkNotActive ? 'router-link' : 'button';
  }

  get linkName(): nameOrNull {
    return this.isLinkNotActive ? { name: this.to } : null;
  }

  onClick(): void {
    if (!this.to) {
      this.$emit('click');
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/profilemenu/components/button/ProfileButton.vue